<template>
    <button id="BackButton" :class="{'Backbutton--inactive': onHomePage}" @click="navigateBack" aria-label="back">
        <img class="bg" src="@/assets/img/ui/back-bg.svg">
        <img class="arrow" src="@/assets/img/ui/back-arrow.svg">
    </button>
</template>
<script>
import { previousRoute } from '@/router/router';

export default {
    methods: {
        navigateBack() {
            if (this.isCrosslink) {
                app.api.PageManager.navigateBack();
            } else {
                app.api.PageManager.navigateToParentScene();
                app.api.Utils.unmuteAudioManager();
            }
        },
        stripContentComponent(path) {
            return path.split(':')[0];
        }
    },
    computed: {
        onHomePage() {
            this.$route;
            return app.api.PageManager.onHomePage()
        },
        isCrosslink() {
            if (!previousRoute) 
                return false;

            const currentSegments = this.stripContentComponent(this.$route.path).split('/').filter(Boolean);
            const previousSegments = this.stripContentComponent(previousRoute.path).split('/').filter(Boolean);

            // Deep links from outside with no previous segments is not a crosslink
            if(previousSegments.length === 0)
                return false

            // Compare the segments to determine if it’s a crosslink
            for (let i = 0; i < Math.min(currentSegments.length, previousSegments.length); i++) {
                if (currentSegments[i] !== previousSegments[i]) {
                    return true;
                }
            }

            // check if it skips levels, treat it as a crosslink
            if(currentSegments.length > previousSegments.length + 1) 
                return true

            return false;
        }
    }
}
</script>
<style lang="scss" scoped>
    #BackButton {
        left: 50px;

        position: absolute;
        width: 178px;
        top: 10px;
  
        z-index: 2;
        cursor: pointer;
        display: flex;
        justify-content: center;
        
        &>img.bg {
            width: 100%;
            opacity: 0.85;
        }
  
        &>img.arrow {
            top:18px;
            width: 30px;
            position: absolute;
        }
    }

    .Backbutton--inactive {
        opacity: 0;
        pointer-events: none !important;
    }
</style>